import GameAnimations from "./animations/GameAnimations";
import LeftSideGridAnimations from "./animations/LeftSideGridAnimations";
import TopSideGridAnimations from "./animations/TopSideGridAnimations";
import AlignManager from "./config/AlignManager";
import ResourcesDispatcher from "./config/ResourcesDispatcher";
import Cell from "./gameUtil/Base/Cell";
import FreeSpinCell from "./gameUtil/Free/FreeSpinCell";
import FreeSpinReel from "./gameUtil/Free/FreeSpinReel";
import Pick from "./gameUtil/Pick/Pick";
import CreationManager from "./managers/CreationManager";
import Resize from "./utils/Resize";
import Utils from "./utils/Utils";
const api = {
    CreationManager,
    FreeSpinCell,
    FreeSpinReel,
    ResourcesDispatcher,
    Pick,
    GameAnimations,
    Cell,
    Utils,
    AlignManager,
    Resize,
    LeftSideGridAnimations,
    TopSideGridAnimations
};
window.animationLib = api;
